import {
  ThreadRun,
  ThreadSummary,
} from '@/experiences/sales-portal/domain/superintelligence/blocs/services/thread-api';

export interface ThreadItemDetails {
  lastRun: ThreadRun | null;
  persisted: boolean;
  updatedAt?: string;
}

export const threadItemCustom = (
  summary: ThreadSummary,
): Record<string, unknown> => ({
  lastRun: summary.lastRun,
  persisted: true,
  updatedAt: summary.updatedAt,
});

export const readThreadItemDetails = (
  custom: Record<string, unknown> | undefined,
): ThreadItemDetails => ({
  lastRun: (custom?.lastRun as ThreadRun | null | undefined) ?? null,
  persisted: custom?.persisted === true,
  updatedAt:
    typeof custom?.updatedAt === 'string' ? custom.updatedAt : undefined,
});
